export default "__VITE_ASSET__CPmdB91i__"